import React from "react";
import { ApiMessageType } from "src/store/chat/api";
import { Message, MessageType, SystemMessageType } from "../types";
import { Text } from "@evvve/ui-kit";
import Link from "src/shared-features/Link";
import { findFirstUrlSubstring } from "src/helpers/url";
import style from "./style.module.scss";
import moment from "moment";

export const createMessageFromApi = (message: ApiMessageType) => {
  let msg: Message | null = null;

  if (message.type === MessageType.User)
    msg = {
      type: MessageType.User,
      id: message.id,
      userId: message.user?.id,
      avatarUrl: message.user?.data.avatar_link,
      caption: message.user?.data.name,
      text: createUserMessageText(message.text),
      datetime: message.datetime,
    };
  else if (message.type === MessageType.System) {
    const smt = message.system_metadata.type;
    if (smt === SystemMessageType.IAmSpeakerAtTheEvent) {
      msg = {
        type: MessageType.System,
        systemMessageType: SystemMessageType.IAmSpeakerAtTheEvent,
        id: message.id,
        eventId: message.system_metadata.data.event_id,
        eventTitle: message.system_metadata.data.event_name,
        eventDate: moment.utc(message.system_metadata.data.event_date),
      };
    } else if (smt === SystemMessageType.IWillNotBeASpeakerAtTheEvent) {
      msg = {
        type: MessageType.System,
        systemMessageType: SystemMessageType.IWillNotBeASpeakerAtTheEvent,
        id: message.id,
        eventId: message.system_metadata.data.event_id,
        eventTitle: message.system_metadata.data.event_name,
      };
    } else if (smt === SystemMessageType.EventDetailsHaveChanged) {
      const new_date = message.system_metadata.data.new_date;
      const new_start_time = message.system_metadata.data.new_start_time;
      const new_end_time = message.system_metadata.data.new_end_time;

      msg = {
        type: MessageType.System,
        systemMessageType: SystemMessageType.EventDetailsHaveChanged,
        id: message.id,
        eventId: message.system_metadata.data.event_id,
        eventTitle: message.system_metadata.data.event_name,
        newDate: new_date ? moment.utc(new_date) : void 0,
        newStartTime: new_start_time ? moment.utc(new_start_time) : void 0,
        newEndTime: new_end_time ? moment.utc(new_end_time) : void 0,
      };
    } else if (smt === SystemMessageType.NewSpeakerAtTheEvent) {
      msg = {
        type: MessageType.System,
        systemMessageType: SystemMessageType.NewSpeakerAtTheEvent,
        id: message.id,
        eventId: message.system_metadata.data.event_id,
        eventTitle: message.system_metadata.data.event_name,
        speakerId: message.system_metadata.data.speaker_id,
      };
    } else if (smt === SystemMessageType.YouHaveBeenInvitedToBeASpeaker) {
      msg = {
        type: MessageType.System,
        systemMessageType: SystemMessageType.YouHaveBeenInvitedToBeASpeaker,
        id: message.id,
        eventId: message.system_metadata.data.event_id,
        eventTitle: message.system_metadata.data.event_name,
        organizerId: message.system_metadata.data.organizer_id,
        eventDate: moment.utc(message.system_metadata.data.event_date),
      };
    } else if (smt === SystemMessageType.TheEventHasBeenCancelled) {
      msg = {
        type: MessageType.System,
        systemMessageType: SystemMessageType.TheEventHasBeenCancelled,
        id: message.id,
        eventTitle: message.system_metadata.data.event_name,
      };
    } else if (smt === SystemMessageType.WelcomeToTheEvent) {
      msg = {
        type: MessageType.System,
        systemMessageType: SystemMessageType.WelcomeToTheEvent,
        id: message.id,
        eventId: message.system_metadata.data.event_id,
        eventTitle: message.system_metadata.data.event_name,
      };
    } else if (smt === SystemMessageType.IAcceptedToBeASpeakerAtTheEvent) {
      msg = {
        type: MessageType.System,
        systemMessageType: SystemMessageType.IAcceptedToBeASpeakerAtTheEvent,
        id: message.id,
        eventId: message.system_metadata.data.event_id,
        eventTitle: message.system_metadata.data.event_name,
        eventDate: moment.utc(message.system_metadata.data.event_date),
        eventPrice: message.system_metadata.data.event_price,
      };
    } else if (smt === SystemMessageType.IAmOrganizingTheEvent) {
      msg = {
        type: MessageType.System,
        systemMessageType: SystemMessageType.IAmOrganizingTheEvent,
        id: message.id,
        eventId: message.system_metadata.data.event_id,
        eventTitle: message.system_metadata.data.event_name,
        eventDate: moment.utc(message.system_metadata.data.event_date),
      };
    } else if (smt === SystemMessageType.InvitationToGoLive) {
      const {
        event_id: eventId,
        session_id: sessionId,
        cancelled_by_organizer: cancelledByOrganizer,
        cancelled_by_speaker: cancelledBySpeaker,
      } = message.system_metadata.data;

      const senderId = message.system_metadata.sender_id;

      msg = {
        type: MessageType.System,
        systemMessageType: SystemMessageType.InvitationToGoLive,
        id: message.id,
        datetime: message.datetime,
        eventId,
        sessionId,
        senderId,
        cancelledByOrganizer,
        cancelledBySpeaker,
      };
    } else if (smt === SystemMessageType.WelcomeToEvvve)
      msg = {
        id: message.id,
        type: MessageType.System,
        systemMessageType: SystemMessageType.WelcomeToEvvve,
        datetime: message.datetime,
      };
    else if (smt === SystemMessageType.EventDurationExceeded)
      msg = {
        id: message.id,
        type: MessageType.System,
        systemMessageType: SystemMessageType.EventDurationExceeded,
        datetime: message.datetime,
      };
    else if (smt === SystemMessageType.TheEventStartsIn3Hours)
      msg = {
        id: message.id,
        type: MessageType.System,
        systemMessageType: SystemMessageType.TheEventStartsIn3Hours,
        datetime: message.datetime,
        eventTitle: message.system_metadata.data.event_name,
        eventId: message.system_metadata.data.event_id,
      };
    else if (smt === SystemMessageType.TheEventStartsIn15Min)
      msg = {
        id: message.id,
        type: MessageType.System,
        systemMessageType: SystemMessageType.TheEventStartsIn15Min,
        datetime: message.datetime,
        eventTitle: message.system_metadata.data.event_name,
        eventId: message.system_metadata.data.event_id,
      };
    else if (smt === SystemMessageType.TheEventIsLive)
      msg = {
        id: message.id,
        type: MessageType.System,
        systemMessageType: SystemMessageType.TheEventIsLive,
        datetime: message.datetime,
        eventTitle: message.system_metadata.data.event_name,
        eventId: message.system_metadata.data.event_id,
      };
  }

  return msg;
};

enum UserMessageTextType {
  Plain,
  URL,
}

interface UserMessageTextPlain {
  type: UserMessageTextType.Plain,
  data: {
    text: string;
  }
}

interface UserMessageTextUrl {
  type: UserMessageTextType.URL,
  data: {
    url: string;
    text: string;
  }
}

export type UserMessageText = (UserMessageTextPlain | UserMessageTextUrl)[];

const parseMessageText = (text: string ): UserMessageText | null => {
  if (!text)
    return null;

  const url = findFirstUrlSubstring(text);

  if (!url)
    return [{
      type: UserMessageTextType.Plain,
      data: { text },
    }];

  const {
    urlSubstring,
    urlSubstringStartIndex,
    urlSubstringLength,
    href,
  } = url;

  const urlSubstringLastIndex = urlSubstringStartIndex + urlSubstringLength;

  const textPart = text.slice(0, urlSubstringStartIndex);
  const textElement: UserMessageTextPlain | null = textPart ? {
    type: UserMessageTextType.Plain,
    data: { text: textPart },
  } : null;

  const urlElement = {
    type: UserMessageTextType.URL,
    data: {
      url: href,
      text: urlSubstring,
    },
  };

  const resultSeries: UserMessageText = [];

  if (textElement)
    resultSeries.push(textElement);

  resultSeries.push(urlElement);

  return resultSeries.concat(parseMessageText(text.slice(urlSubstringLastIndex)) || []);
};

const createUserMessageText = (text?: string | null | false): React.ReactNode => {
  if (!text)
    return null;

  const textSeries = parseMessageText(text);

  if (!textSeries)
    return null;

  const textNodes = textSeries.map(t => {
    if (t.type === UserMessageTextType.Plain)
      return t.data.text;

    if (t.type === UserMessageTextType.URL)
      return (
        <Link to={t.data.url} external={true} target="_blank" className={style.link}>
          <Text color="violet" size="s">{t.data.text}</Text>
        </Link>
      );
  });

  return textNodes;
};
